import * as React from 'react';
import { styleSingleton } from 'react-style-singleton';
import { focusHiddenMarker } from './medium';
var Style = styleSingleton();
var styles = "\n [" + focusHiddenMarker + "] {\n   pointer-events: none !important;\n }\n";
export var InteractivityDisabler = function () {
  return React.createElement(Style, {
    styles: styles
  });
};